interface Tab {
  id: string
  label: string
}

interface Props {
  tabs: Tab[]
  active: string
  onSelect: (id: string) => void
}

/**
 * Segmented tab bar over the two hero scenes.
 *
 * Selecting a tab bumps a counter in the parent even when re-selecting the
 * active one, so clicking the current tab replays its animation from step 0.
 */
export function SceneTabs({ tabs, active, onSelect }: Props) {
  return (
    <div className="tl-hero-tabs" role="tablist" aria-label="Hero diagram scene">
      {tabs.map((tab) => {
        const isActive = tab.id === active
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            data-active={isActive}
            className="tl-hero-tab focus-ring"
            onClick={() => onSelect(tab.id)}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
